import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TRequestWorkerPaycardsRequest } from "../requestContractorPaycards/requestContractorPaycards.schema";

export const requestEmployeePaycards = (axios: IAxiosInstance) => {
  return async ({ workerId, ...data }: TRequestWorkerPaycardsRequest) => {
    const response = await axios.noRetry.post(
      `/api/employees/${workerId}/paycards/request`,
      data
    );

    return response; // returns 204 no data
  };
};
